<template>
  <div class="page-domain-details">
    <Overlay width="x-small" :link="closeLink">
      <h2 class="overlay-heading">Domain Contact Details</h2>

      <DomainContactForm
        v-model="contactDetails"
        :btnLoading="btnLoading"
        @submit="submit"
        :errors="errors"
        :companyName="companyName"
      />
    </Overlay>
  </div>
</template>

<script>
import page from '@/mixins/page'
import {mapState} from 'vuex'

import Overlay from '@/components/Overlay'
import DomainContactForm from '@/components/forms/DomainContactForm'

export default {
  name: 'domains-contact-details',

  mixins: [page],

  props: {
    companyId: {
      type: String,
      required: true
    },

    companyName: {
      type: String
    }
  },

  components: {
    Overlay,
    DomainContactForm
  },

  data() {
    return {
      title: 'Domain Contact Details',
      contactDetails: {
        firstName: '',
        lastName: '',
        companyName: '',
        email: ''
      },
      btnLoading: false,
      errors: {}
    }
  },

  methods: {
    submit() {
      this.btnLoading = true
      this.$emit('contactDetails', this.contactDetails)
    }
  },

  computed: {
    ...mapState(['currentUser']),

    closeLink() {
      return {
        name: 'domain-search',
        params: {
          companyId: this.companyId
        }
      }
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'
</style>
